import type { AnalyticsProvider, AnalyticsContext } from '../analytics';
import { ga4Service } from '../ga4Service';
import { configService } from '../../configService';
import { createFileLogger } from '../../../utils/logger';

const log = createFileLogger('GA4_PROVIDER');

export class GA4Provider implements AnalyticsProvider {
  readonly name = 'ga4';

  async init(_ctx: AnalyticsContext): Promise<void> {
    try {
      const measurementId = await configService.getGAMeasurementId();
      if (measurementId) {
        ga4Service.setMeasurementId(measurementId);
      }
    } catch (err) {
      log.warn('Failed to load GA measurement ID from config:', err);
    }
    ga4Service.init();
  }

  track(event: string, props: Record<string, unknown>): void {
    ga4Service.track(event, props as Record<string, any>);
  }

  identify(userId: string, _traits?: Record<string, unknown>): void {
    ga4Service.identify(userId);
  }

  page(path: string, props?: Record<string, unknown>): void {
    ga4Service.trackPageView(props?.page_title as string | undefined, path);
  }

  // GA4 does not natively support group calls
  group(_orgId: string, _traits?: Record<string, unknown>): void {}

  reset(): void {
    // GA4 has no reset concept; user_id is cleared on next identify
  }

  async flush(): Promise<void> {
    await ga4Service.flushEvents();
  }
}
